const messages = {
  title: "Prislister, brochurer & SoMe",
  brochure_prices: "Prislister, brochurer & SoMe",
  description:
    "Download de seneste brochurer og flyers om vores Bridgestone og Firestone dæk til personbiler, SUV'er og varevogne her.",
  brochureCategories: {
    products: "Produkter",
    brand_and_solutions: "Mærke",
    season_and_promotions: "Sæson og kampagner",
    format: "Format",
    cars_and_vans: "Personvogn & varevogn",
    summer: "Sommer",
    winter: "Vinter",
    promotions: "Kampagner",
    all_season: "Helårs",
    truck_and_buses: "Lastbiler og busser",
    motorcycle: "Motorcykel",
    agriculture: "Landbrug",
    construction_machinery: "Entreprenørmaskiner",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialer",
    brochures: "Produktbrochurer",
    price_list: "Prislister",
    materials: "Materialer",
    video_in_store: "Video med undertekster",
    video_online: "Video uden undertekster",
    banner_website: "Banner",
    banner_social_media: "Sociale medier",
    logos: "Logos",
    some: "Sociale Medier",
  },
  searchMedia: "Indtast søgeord",
  searchResults: "Søgeresultater",
};
export default {
  messages,
};
